import React, { Component } from 'react'

export class Location extends Component {
  render() {
    return (
      <div>Location</div>
    )
  }
}

export default Location